import React, { FC, ReactNode } from 'react'
import { NavLink, NavLinkProps } from 'react-router-dom'
import { Box } from 'front-end/src/components'
import { BoxProps } from '@chakra-ui/react'

import './TabsLegacy.less'

export const Tab = (
  props: Pick<NavLinkProps, 'to'> & Partial<NavLinkProps>
): JSX.Element => (
  <NavLink
    className="TabsLegacy__list-item"
    activeClassName="selected"
    role="tab"
    {...props}
  />
)

interface ITabsProps {
  tabs: ReactNode
  panels: ReactNode
}

export const PageWithTabs: FC<ITabsProps & Omit<BoxProps, 'children'>> = ({
  tabs,
  panels,
  ...rest
}) => (
  <Box className="TabsLegacy" {...rest}>
    <TabsWrapper>{tabs}</TabsWrapper>
    <PanelWrapper>{panels}</PanelWrapper>
  </Box>
)

export const TabsWrapper: FC<BoxProps> = (props) => (
  <Box className="TabsLegacy__list__wrapper" {...props}>
    <Box
      className="TabsLegacy__list"
      role="tablist"
      data-test="TabList"
      {...props}
    />
  </Box>
)

export const PanelWrapper: FC<BoxProps> = (props) => (
  <Box className="TabsLegacy__panel selected" {...props} />
)
